import React, {  useState, useEffect } from "react";
import { FormattedMessage } from 'react-intl';
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import logo from "../../../../assets/images/fnlogo.jpeg";
import "../otp/otp/otp.scss";
import storage from "utils/storage";
import classNames from "classnames";
import Alert from "@material-ui/lab/Alert";
import { BsPencil } from "react-icons/bs";
import { useIntl } from "react-intl";
import * as commonService from "utils/CommonService.js";
import { getSource } from "utils/CommonService";
import * as authActions from "redux/actions/AuthActions";
import { clearPhoneLogin, hasPhoneLogin, sendPhoneOtp, confirmPhoneOtp, phoneAuthError } from '../../../../utils/phoneAuth';

const VerifyOTP = ({ history }) => {
  const [busy, setBusy] = useState(false);
  const [verified, setVerified] = useState(false);
  const [counter, setCounter] = useState(60); // timeout for OTP to 60 seconds
  const number = storage.get("humlog_user_contact");
  const [errorMessage, setErrorMessage] = useState("");
  const translate = useIntl();
  const dispatch = useDispatch();
  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
  });

  /**
   * method to verify otp
   * @param {Object} val values enter by user (OTP)
   * 
   */
  const verifyOtp = async (val) => {
    if (busy || verified) return;
    setBusy(true);
    setErrorMessage('');
    commonService.isLoading.onNext(true); // show loader while Firebase verifies the OTP
    try {
      // Firebase confirms the OTP was correct for this phone number...
      const idToken = await confirmPhoneOtp(number, val.otp);
      // ...then the backend independently re-verifies that Firebase ID token
      // (via Firebase Admin) before it trusts the number as verified and logs the user in.
      const res = await dispatch(authActions.verifyOTP({
        user_name: `${number}`,
        login_type: 'contact',
        firebase_id_token: idToken,
        lead_source: getSource(),
      }));
      if (res.value.success) {
        clearPhoneLogin();
        setVerified(true);
        storage.set("profile_status", res.value.data.profile_status);
        commonService.forSuccess(res.value.message, "Success");
        const redirect_url = history.location.state;
        if (res.value.data.profile_status) {
          history.push(redirect_url || "/jobs");
        } else {
          history.push({ pathname: "/user/basicdetail", state: redirect_url });
        }
      }
    } catch (err) {
      // err.data means the backend rejected the request (e.g. token verification failed);
      // anything else is a Firebase-side error (wrong code, expired session, etc.)
      setErrorMessage(err.data ? (err.data.message || 'Unable to verify OTP. Please try again.') : phoneAuthError(err));
    } finally {
      setBusy(false);
      commonService.isLoading.onNext(false);
    }
  };

  useEffect(() => {
    if (!hasPhoneLogin(number)) {
      history.replace({ pathname: '/JobSeekerlogin', state: history.location.state });
    }
  }, [history, number]);
  useEffect(() => {
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  const resendOtp = async () => {
    if (busy || counter > 0 || verified) return;
    setBusy(true);
    setErrorMessage('');
    commonService.isLoading.onNext(true); // show loader while Firebase resends the OTP
    try {
      await sendPhoneOtp(number, 'firebase-resend-recaptcha');
      setCounter(60);
    } catch (err) {
      setErrorMessage(phoneAuthError(err));
    } finally {
      setBusy(false);
      commonService.isLoading.onNext(false);
    }
  };
  return (
    <>
      <div className="top_main">
        <div id="firebase-resend-recaptcha" />
        <div className="verify_otp_main">
          <div className="row no-gutters">
            <div className="col-md-4"></div>
            <div className="col-md-4 otp_rb sha p-4 ">
              <div className="px-3 px-lg-5 pt-3">
                <div className="d-flex justify-content-center">
                  <img src={logo} width="200px" alt="logo" className="mx-auto" />
                </div>
                <p className="otp_ver text-center mt-3 mb-3 font-bold">
                  {" "}
                  <FormattedMessage id = "otpVerification" defaultMessage="OTP Verfication" />
                </p>
                <div>
                  <form onSubmit={handleSubmit(verifyOtp)}>
                    <div className="login_details">
                      <div className="otp_b text-bold p-0 m-0 mb-1 text-center">
                        <p>
                          {" "}
                          <FormattedMessage
                            id="enterOtp"
                            defaultMessage="Enter OTP sent to +91 {number}"
                            values={{ number: number }}
                          />
                          <BsPencil
                            className="pencil"
                            onClick={() => { if (!busy) history.push({ pathname: '/JobSeekerlogin', state: history.location.state }); }}
                            style={{float:'right'}}
                          />
                        </p>
                      </div>
                      <input
                        name="otp"
                        autoComplete="one-time-code"
                        inputMode="numeric"
                        maxLength={6}
                        disabled={busy || verified}
                        className={classNames("form-control", {
                          "is-invalid": errors.otp,
                        })}
                        ref={register({
                          required: translate.formatMessage({ id: 'mustEnterOtp' }),
                          pattern: { value: /^\d{6}$/, message: 'Please enter the six-digit OTP.' },
                        })}
                      />
                      {errors.otp && (
                        <p className="text-danger tnc_alrt ">
                          {errors.otp.message}
                        </p>
                      )}
                      <div>{counter ?
                        (<div className="mt-2 d-flex justify-content-center mb-3 mt-2text-capitalize">
                          {" "}
                          <p className="text-center" ><FormattedMessage id="resendOtpIn"/><span className="text-success">{counter} </span> secs </p>{" "}
                        </div>
                        ) :
                        (<div className="mt-2 d-flex justify-content-center mb-3 mt-2text-capitalize">
                          <FormattedMessage id="notReceiveOtp"/>
                          <button type="button" disabled={busy || verified} className="btn btn-link text-decoration-none ml-1 cursor_otp" onClick={resendOtp}>
                            <FormattedMessage id="resendOtp"/>
                          </button>{" "}
                        </div>)
                      }
                      </div>
                      <button className="common_btn login_btn" type="submit" disabled={busy || verified}>
                        <FormattedMessage id="verifyAndProceed"/>
                      </button>
                    </div>
                  </form>
                  <div className="mt-3">
                    {verified && <Alert severity="success">Mobile number verified successfully.</Alert>}
                    {errorMessage && errorMessage.length > 0 && (
                      <Alert severity="error">{errorMessage} !</Alert>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default VerifyOTP;
